 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~views-pages-advanced-form-elements-advanced-form-elements-module~views-pages-apps-apps-modul~d99f285b":"default~views-pages-advanced-form-elements-advanced-form-elements-module~views-pages-apps-apps-modul~d99f285b","common":"common","views-pages-apps-apps-module":"views-pages-apps-apps-module","views-pages-daihoi-location-map-location-map-module":"views-pages-daihoi-location-map-location-map-module","default~views-pages-advanced-form-elements-advanced-form-elements-module~views-pages-daihoi-gallary-~dbd48207":"default~views-pages-advanced-form-elements-advanced-form-elements-module~views-pages-daihoi-gallary-~dbd48207","default~views-pages-advanced-form-elements-advanced-form-elements-module~views-pages-form-elements-f~d699c7ec":"default~views-pages-advanced-form-elements-advanced-form-elements-module~views-pages-form-elements-f~d699c7ec","views-pages-advanced-form-elements-advanced-form-elements-module":"views-pages-advanced-form-elements-advanced-form-elements-module","views-pages-daihoi-voting-voting-module":"views-pages-daihoi-voting-voting-module","views-pages-form-elements-form-elements-module":"views-pages-form-elements-form-elements-module","default~views-pages-advanced-ui-advanced-ui-module~views-pages-daihoi-news-news-module":"default~views-pages-advanced-ui-advanced-ui-module~views-pages-daihoi-news-news-module","views-pages-advanced-ui-advanced-ui-module":"views-pages-advanced-ui-advanced-ui-module","default~views-pages-charts-graphs-charts-graphs-module~views-pages-dashboard-dashboard-module":"default~views-pages-charts-graphs-charts-graphs-module~views-pages-dashboard-dashboard-module","views-pages-charts-graphs-charts-graphs-module":"views-pages-charts-graphs-charts-graphs-module","views-pages-dashboard-dashboard-module":"views-pages-dashboard-dashboard-module","default~views-pages-daihoi-addUser-addUser-module~views-pages-daihoi-addUsers-users-module~views-pag~a020fe1a":"default~views-pages-daihoi-addUser-addUser-module~views-pages-daihoi-addUsers-users-module~views-pag~a020fe1a","views-pages-daihoi-chuonngTrinh-chuong-trinh-module":"views-pages-daihoi-chuonngTrinh-chuong-trinh-module","views-pages-daihoi-results-results-module":"views-pages-daihoi-results-results-module","default~views-pages-daihoi-addUser-addUser-module~views-pages-daihoi-addUsers-users-module~views-pag~c19961e1":"default~views-pages-daihoi-addUser-addUser-module~views-pages-daihoi-addUsers-users-module~views-pag~c19961e1","views-pages-daihoi-news-news-module":"views-pages-daihoi-news-news-module","default~views-pages-daihoi-addUser-addUser-module~views-pages-daihoi-addUsers-users-module":"default~views-pages-daihoi-addUser-addUser-module~views-pages-daihoi-addUsers-users-module","views-pages-daihoi-addUser-addUser-module":"views-pages-daihoi-addUser-addUser-module","views-pages-daihoi-addUsers-users-module":"views-pages-daihoi-addUsers-users-module","default~views-pages-daihoi-daibieuthamgia-dsdaibieu-module~views-pages-daihoi-gallary-gallary-module":"default~views-pages-daihoi-daibieuthamgia-dsdaibieu-module~views-pages-daihoi-gallary-gallary-module","views-pages-daihoi-daibieuthamgia-dsdaibieu-module":"views-pages-daihoi-daibieuthamgia-dsdaibieu-module","default~views-pages-daihoi-gallary-gallary-module~views-pages-tables-tables-module":"default~views-pages-daihoi-gallary-gallary-module~views-pages-tables-tables-module","views-pages-daihoi-gallary-gallary-module":"views-pages-daihoi-gallary-gallary-module","views-pages-tables-tables-module":"views-pages-tables-tables-module","highlight-js-lib-core":"highlight-js-lib-core","highlight-js-lib-languages-scss":"highlight-js-lib-languages-scss","highlight-js-lib-languages-typescript":"highlight-js-lib-languages-typescript","highlight-js-lib-languages-xml":"highlight-js-lib-languages-xml","views-pages-auth-auth-module":"views-pages-auth-auth-module","views-pages-daihoi-account-account-module":"views-pages-daihoi-account-account-module","views-pages-daihoi-avatar-framer-avatar-framer-module":"views-pages-daihoi-avatar-framer-avatar-framer-module","views-pages-daihoi-banner-banner-module":"views-pages-daihoi-banner-banner-module","views-pages-daihoi-convertImg-convertImg-module":"views-pages-daihoi-convertImg-convertImg-module","views-pages-daihoi-customCreate-customCreate-module":"views-pages-daihoi-customCreate-customCreate-module","views-pages-daihoi-customImg-customImg-module":"views-pages-daihoi-customImg-customImg-module","views-pages-daihoi-exam-exam-module":"views-pages-daihoi-exam-exam-module","views-pages-general-general-module":"views-pages-general-general-module","views-pages-icons-icons-module":"views-pages-icons-icons-module","views-pages-ui-components-ui-components-module":"views-pages-ui-components-ui-components-module","quill":"quill","sweetalert2":"sweetalert2","date":"date"}[chunkId]||chunkId) + "-es2015." + {"default~views-pages-advanced-form-elements-advanced-form-elements-module~views-pages-apps-apps-modul~d99f285b":"8f1c6f932b89e3a7d73b","common":"e78e4a8ae0f48ac5e7df","views-pages-apps-apps-module":"fe2f440aa80facf06bf6","views-pages-daihoi-location-map-location-map-module":"248945dc01b23ef8e40b","default~views-pages-advanced-form-elements-advanced-form-elements-module~views-pages-daihoi-gallary-~dbd48207":"12b965a38546c31805f3","default~views-pages-advanced-form-elements-advanced-form-elements-module~views-pages-form-elements-f~d699c7ec":"4751f864092c6aa20f5c","views-pages-advanced-form-elements-advanced-form-elements-module":"a0681dc6a59b96375897","views-pages-daihoi-voting-voting-module":"d769d40890551a9b4809","views-pages-form-elements-form-elements-module":"a9aaca9fdb34b4f0cc19","default~views-pages-advanced-ui-advanced-ui-module~views-pages-daihoi-news-news-module":"93b2f46d9b0160eb6eff","views-pages-advanced-ui-advanced-ui-module":"8096275953779de8f6a6","default~views-pages-charts-graphs-charts-graphs-module~views-pages-dashboard-dashboard-module":"97c359c31d1cf415075a","views-pages-charts-graphs-charts-graphs-module":"9d45154bd6031165b05f","views-pages-dashboard-dashboard-module":"12c56ac4fa11f7843930","default~views-pages-daihoi-addUser-addUser-module~views-pages-daihoi-addUsers-users-module~views-pag~a020fe1a":"52b76bd308156c86b98f","views-pages-daihoi-chuonngTrinh-chuong-trinh-module":"960c080afeaa4ca124e8","views-pages-daihoi-results-results-module":"e373694dd6bd93b6982b","default~views-pages-daihoi-addUser-addUser-module~views-pages-daihoi-addUsers-users-module~views-pag~c19961e1":"bfcf9b97094a6bab04a2","views-pages-daihoi-news-news-module":"bb124d8536ce3540f99e","default~views-pages-daihoi-addUser-addUser-module~views-pages-daihoi-addUsers-users-module":"d717ef229a62246a7373","views-pages-daihoi-addUser-addUser-module":"0a7ee49e920c8d40fb68","views-pages-daihoi-addUsers-users-module":"1f14eb96a190a8e17973","default~views-pages-daihoi-daibieuthamgia-dsdaibieu-module~views-pages-daihoi-gallary-gallary-module":"6d795245237c7023b8b2","views-pages-daihoi-daibieuthamgia-dsdaibieu-module":"fd499cc37ef3036631cd","default~views-pages-daihoi-gallary-gallary-module~views-pages-tables-tables-module":"e02663d4889b3fc231df","views-pages-daihoi-gallary-gallary-module":"6a4c2a3e651e81a67d60","views-pages-tables-tables-module":"779cfce6e08ce4589b9a","highlight-js-lib-core":"6c81afb312dd85cced65","highlight-js-lib-languages-scss":"93ff510a820b7bee55db","highlight-js-lib-languages-typescript":"d3dd35a5404f4108c4c0","highlight-js-lib-languages-xml":"e45331aa1b0b3af4285d","views-pages-auth-auth-module":"a13f52e1651b7b9ea50a","views-pages-daihoi-account-account-module":"acf9cb0c0c6c58d24c2b","views-pages-daihoi-avatar-framer-avatar-framer-module":"8519799508425dd2d7e6","views-pages-daihoi-banner-banner-module":"1b29dc46c6d3610f53ff","views-pages-daihoi-convertImg-convertImg-module":"bf70d3f036a3ef596264","views-pages-daihoi-customCreate-customCreate-module":"92839910fad4787d162a","views-pages-daihoi-customImg-customImg-module":"a9d4906a3794f7a2499c","views-pages-daihoi-exam-exam-module":"5dd7938436c57252c9b3","views-pages-general-general-module":"ff69ca4029e060341463","views-pages-icons-icons-module":"cd69f87f4d8ea8ccdf76","views-pages-ui-components-ui-components-module":"143d11ddb41b2791f3b3","quill":"bb6bf59625d8e04bafe7","sweetalert2":"aa68da08d7494825beb5","date":"25fc49c32d8cd49fa4bb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
